<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2BfD5w/tc-custom/9781625846303.jpg?1705233290076" alt="This image is the cover for the book Montana Territory and the Civil War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Montana Territory and the Civil War
      </h1>
      <p class="bookDescription body article font2">
        <b>A compelling portrait of how the passions of the Civil War played out among gold miners in the remote mountains of the West.</b><br/>  <br/> In 1862, gold discoveries brought thousands of miners to camps along Grasshopper Creek—and by 1864, the Federal government had carved the Montana Territory out of the existing Idaho and Dakota Territories. Gold from Montana Territory fueled the Union war effort, yet loyalties were mixed among the miners.<br/>  <br/> In this compelling collection of stories, historian Ken Robison illustrates how Southern sympathizers and Union loyalists, deserters and veterans, freed slaves and former slaveholders living side by side made a volatile and vibrant mix that molded Montana. Discover how fiery personalities like Union Colonel Sidney Edgerton and General Thomas Francis Meagher fought to keep order in the newly formed frontier, while brave Confederate and Union veterans and their hardy families created an enduring legacy that helped shape modern Montana.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ken Robison
      </h2>
      
      <p class="authorDescription body article">Ken Robison, a native Montanan, is a historian at the Overholser Historical Research Center and trustee of the River and Plains Society and Museum Complex in Fort Benton. He serves as historian for the Great Falls/Cascade County Historic Preservation Commission and is active in historic preservation in central Montana.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75ff695b